export default __webpack_public_path__ + "4d570935b374166f75955f40ffb46011.exr";